import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  '@global': {
    // for global styles
  },
}));

export default useStyles;
